<template lang="pug">
  .registration-suggestion
    .popup-view
      .content
        .title
          span その質問、すべて
          span 電話カウンセリングで解決します！
        .frame-view
          img(:src="imageSrc")
          span.close-image(@click="$emit('closePopup')")
            img(:src="closeImageSrc")
        .content-body
          span.item オンラインレッスンってどんな感じ？
          span.item 初心者もオンラインで上達できるの？
          span.item 無料体験レッスンの詳細を知りたい！
        large-multiline-button(
          title="電話カウンセリングに申し込む"
          class="button"
          @click="$emit('didTapApplication')")
        .content-footer
          span.item 新規登録後に、電話カウンセリングのご案内を
          span.item チャットでお送りします。
</template>

<script>
import LargeMultilineButton from '@/components/atoms/LargeMultilineButton'

export default {
  name: 'EncourageRegistration',
  components: { LargeMultilineButton },
  computed: {
    imageSrc() {
      return require(`@/assets/retina-images/encourage_registration_img.png`)
    },
    closeImageSrc() {
      return require(`@/assets/retina-images/delete.png`)
    },
  },
}
</script>

<style lang="scss" scoped>
.registration-suggestion {
  position: relative;
  z-index: 1000;
  top: 0;
  display: flex;
  justify-content: center;
  overflow: auto;
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);

  .popup-view {
    position: absolute;
    background-color: #fff;
    border-radius: 8px;
    width: 100%;
    max-width: 325px;
    top: 32px;
    margin-bottom: 25px;

    .content {
      padding: 24px;
      color: #222222;
      text-align: center;
      font-weight: 900;

      .title {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        line-height: 19px;
      }

      .content-body {
        display: flex;
        flex-direction: column;
        font-size: 13px;
        line-height: 18px;
        margin: 24px 0;

        .item {
          margin: 10px 0;
        }
      }

      .content-footer {
        color: rgba(204, 204, 204, 1);
        font-weight: normal;
        font-size: 11px;
        line-height: 15px;
        margin-top: 18px;
        margin-bottom: 20px;
      }

      .frame-view {
        margin: 24px 0;
        width: 100%;

        .close-image {
          position: absolute;
          top: -20px;
          right: -20px;
        }
      }

      .button {
        margin: 0 !important;
        width: 100%;
      }
    }

    @media (min-width: 320px) and (max-width: 414px) {
      align-self: center;
      top: unset;
    }

    @media (min-width: 768px) and (min-height: 768px) {
      align-self: center;
      top: unset;
    }
  }
}
</style>
